import { useEffect, useState } from 'react';
import { getTypeProductById, getTypeProducts } from '../services/TypeService'

export const useTypeProduct = () => {
    const [typeProduct, setTypeProduct] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTypeProduct = async () => {
        setLoading(true);
        try {
            const response = await getTypeProducts();
            setTypeProduct(response.data);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
    };

    const fetchsetTypeProductById = async (id) => {
        try {
            const response = await getTypeProductById(id);
            setTypeProduct(typeProduct.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update categories');
        }
    };

    useEffect(() => {
        fetchTypeProduct();
    }, []);

    return {
        loading,
        error,
        typeProduct,
        alert,
        fetchTypeProduct,
        fetchsetTypeProductById
    };
}